import React from 'react';

import CustomHalfPieChart from 'components/CustomHalfPieChart';
import { SpaceAnalyticsResponseModel } from 'api';

import styles from '../TrackersCompletenessChart/TrackersCompletenessChart.module.less';

const COLORS = ['#00AA63', '#E6E6E6'];
const STROKE_COLORS = ['rgba(0,170,99,0.20)', 'rgba(230,230,230,0.45)'];

type Props = {
  spaceAnalyticsInfo: SpaceAnalyticsResponseModel;
};

export default function ProjectsCompletenessChart(props: Props) {
  const {
    spaceAnalyticsInfo: { foldersCount, foldersCompletedCount },
  } = props;
  const foldersUnCompletedCount =
    (foldersCount || 0) - (foldersCompletedCount || 0);

  const data = [
    {
      name: 'Complete',
      value: foldersCompletedCount || 0,
      textColor: '#FFF',
    },
    {
      name: 'In-progress',
      value: foldersUnCompletedCount || 0,
      textColor: '#242424',
    },
  ];

  return (
    <div className={styles.chart}>
      <div className={styles.chartBox}>
        <h1 className={styles.title}>Project progress</h1>

        <div className={styles.trackers}>
          <h2>{foldersUnCompletedCount || 0}</h2>
          <p>In progress</p>
        </div>

        <div className={styles.info}>
          {data.map((data, index) => (
            <div key={index} className={styles.item}>
              <div
                style={{ background: COLORS[index] }}
                className={styles.itemSquare}
              />
              <div>{data.name}</div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.pieChart}>
        <CustomHalfPieChart
          data={data}
          colors={COLORS}
          strokeColors={STROKE_COLORS}
        />
      </div>
    </div>
  );
}
